import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-storymap',
  templateUrl: './storymap.component.html',
  styleUrls: ['./storymap.component.scss']
})
export class StorymapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
